export const GET_SSHKEYS = 'GET_SSHKEYS';
export const ADD_SSHKEY = 'ADD_SSHKEY';
export const DELETE_SSHKEY = 'DELETE_SSHKEY';
export const SSHKEY_ERROR = 'SSHKEY_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SELECT_KEY = 'SELECT_KEY';
export const CANCEL_KEY = 'CANCEL_KEY';


